import React from "react";
import Marquee from "react-fast-marquee";
import { MARQUEE_WORDS } from "@/data/mock";

export default function EditorialMarquee() {
    return (
        <section className="relative border-y border-ink/10 bg-white py-6" data-testid="editorial-marquee">
            <Marquee gradient={false} speed={38} pauseOnHover>
                {[...MARQUEE_WORDS, ...MARQUEE_WORDS].map((w, i) => (
                    <span key={i} className="mx-8 inline-flex items-center gap-8">
                        <span
                            className="serif-italic text-[68px] leading-none text-ink md:text-[92px]"
                            style={{ fontFamily: "Playfair Display", fontWeight: 500 }}
                        >
                            {w}
                        </span>
                        <span className="text-pink text-[68px] md:text-[92px] leading-none">✱</span>
                    </span>
                ))}
            </Marquee>
        </section>
    );
}
